import React from 'react';
import '../../styles/styles.scss';
import { FormattedMessage } from 'react-intl';

const SessionTimeout = (props) => {
  return (
    <div>
      <div className="background">&nbsp;</div>
      <div className="popup center">
        <div className="modal-content">
          <div className="modal-header">
            <h5 className="modal-title" style={{color:'#212529'}}><FormattedMessage id="app.header.session.timeout" /></h5>
          </div>
          <div className="modal-footer">
            <button type="button" className="btn btn-secondary" onClick={()=> window.location.href = window.location.href}>OK</button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default SessionTimeout;
